import { TableConstructor } from './construction/table-constructor';
import { ActionFn, ActionFunctions, Table, TableConstructionData, TableSorter } from './types';

export function buildTable(
  tableConstructionData: TableConstructionData,
  actionHandler?: ActionFn | ActionFunctions
): [Table, TableSorter] {
  return new TableConstructor(actionHandler).buildTable(tableConstructionData);
}
